<template>
  <div class="chi-search-box chi-form-group" style="position: relative">
    <input class="k-textbox md chi-search-field" type="text" @keyup="onkeyup" />
    <i class="fal fa-fw fa-search chi-search-icon"></i>
    <kendo-button style="margin-left: 0.57143rem;" :icon="'previous'" @click="onprev"></kendo-button>
    <input class="chi-search-messages k-textbox message-area sm" readonly="readonly" />
    <kendo-button :icon="'next'" @click="onnext"></kendo-button>
  </div>
</template>

<style lang="scss">
.chi-form .chi-form-group.chi-search-box {
  margin: 0;
}
.chi-search-field {
  padding-right: 1.25rem;
}
.chi-search-icon {
  color: #676d75;
  left: 9.857rem;
  position: absolute;
  text-align: right;
  top: 0.6249rem;
  width: 1.5rem;
}
.chi-search-messages {
  background: transparent !important;
  display: inline-block;
  margin: 0.5rem 0;
  min-width: 6rem;
  width: auto !important;
  &.error {
    color: #ea5e4a !important;
  }
}
.search-match {
  background: #f08346 !important;
  color: #080808 !important;
}
button.search-match, input.search-match, select.search-match, textarea.search-match {
  background: rgba(240, 131, 70, 0.2) !important;
  border: 2px solid rgba(240, 131, 70, 0.7) !important;
}
</style>

<script>
import $ from 'jquery';
import {Button} from '@progress/kendo-buttons-vue-wrapper';

const REGEXPS = {
  DISPLAY_NONE: /\bdisplay:\s*none;/,
  FOLLOWS: /\bfollows\b/,
  PRECEDES: /\bprecedes\b/,
  WHITESPACE: /\s/g,
};

function search_frame() {
  this.reset();
}
search_frame.prototype.append = function (node, value) {
  var length = value.length;
  if (length) {
    value = value.replace(REGEXPS.WHITESPACE, ' ');
    this.length += length;
    this.value += value;
    this.nodes.push({length, node, value});
    return true;
  }
};
search_frame.prototype.rebase = function (index) {
  if (!this.nodes.length)
    return {};
  if (index < 0)
    index = Math.max(0, index + this.length);
  if (index >= this.length)
    this.reset();
  else
    for (var i = 0, offset = 0, len = this.nodes.length; i < len; ++i) {
      var node = this.nodes[i];
      if (offset + node.length > index) {
        this.length -= offset;
        this.nodes.splice(0, i);
        this.start = index - offset;
        this.value = this.value.substring(offset);
        return {chars: offset, nodes: i};
      } else {
        offset += node.length;
      }
    }
  return {};
};
search_frame.prototype.reset = function () {
  this.length = 0;
  this.nodes = [];
  this.start = 0;
  this.value = '';
};

export default {
  name: 'SearchBox',
  components: {
    'kendo-button': Button
  },
  methods: {
    find_in_input: function (node) {
      var value = node.value.toLowerCase();
      for (var i = 0, len = value.length; i < len; i += this.term.length) {
        if ((i = value.indexOf(this.term, i)) === -1)
          break;
        else
          this.matches.push({node});
      }
    },
    find_in_text: function (node) {
      if (this.frame.append(node, node.nodeValue.toLowerCase()))
        do {
          var i = this.frame.value.indexOf(this.term, i || this.frame.start);
          if (i < 0) {
            this.frame.rebase(-this.term.length);
          } else {
            var {chars} = this.frame.rebase(i);
            this.matches.push({
              start: (i -= chars),
              nodes: Array.from(this.frame.nodes),
              is_text: true
            });
            this.frame.rebase(i += this.term.length);
          }
        } while (i >= 0);
    },
    clear_matches: function () {
      $('.search-match', self.searcharea)
        .removeClass('search-match')
        .filter('span')
        .each(function () {
          var next = this.nextSibling;
          var parent = this.parentNode;
          var prev = this.previousSibling;
          var follows =
            REGEXPS.FOLLOWS.test(this.className) &&
            prev && prev.nodeType === Node.TEXT_NODE;
          var precedes =
            REGEXPS.PRECEDES.test(this.className) &&
            next && next.nodeType === Node.TEXT_NODE;
          if (follows && precedes) {
            prev.textContent += this.textContent + next.textContent;
            parent.removeChild(next);
          } else if (follows) {
            prev.textContent += this.textContent;
          } else if (precedes) {
            next.textContent = this.textContent + next.textContent;
          } else {
            parent.insertBefore(this.firstChild, this);
          }
          parent.removeChild(this);
        });
    },
    focus: function (direction, already_cleared) {
      var count = this.matches && this.matches.length;
      if (!count)
        return;
      this.cursor += direction;
      if (this.cursor < 0)
        this.cursor += count;
      else
        this.cursor %= count;
      var entry = this.matches[this.cursor];
      var end = entry.start + this.term.length;
      if (!already_cleared)
        this.clear_matches();
      var searcharea = this.searcharea;
      var scrollto;
      if (entry.is_text)
        for (var i = 0, len = entry.nodes.length; i < len; ++i) {
          var node = entry.nodes[i];
          var range = document.createRange();
          var span = document.createElement('span');
          scrollto = scrollto || $(span);
          span.className = 'search-match';
          if (!i && entry.start > 0)
            span.className += ' follows';
          if (end < node.length)
            span.className += ' precedes';
          range.setStart(node.node, i ? 0 : entry.start);
          range.setEnd(node.node, Math.min(node.length, end));
          range.surroundContents(span);
          end -= node.length;
        }
      else
        scrollto = $(entry.node).addClass('search-match');
      this.messages.val((this.cursor + 1) + ' of ' + this.matches.length);
      searcharea.scrollTop(
        searcharea.scrollTop() + (scrollto.offset().top - searcharea.offset().top)
      );
    },
    onkeyup: function keyup(event, status) {
      var timeout = !(status === 'no-timeout');
      var inc = 1;
      switch (event.key) {
      case 'ArrowDown':
      case 'ArrowLeft':
      case 'ArrowRight':
      case 'ArrowUp':
      case 'Escape':
        // these don't affect the content of the search field, do nothing
        return;
      case 'Enter':
        // 'Enter' keypress always triggers a search
        break;
      case 'Backspace':
      case 'Delete':
        inc = 0;  // these don't count as typing
        // falls through
      default:
        // update count and timestamp
        this.keycount = (this.keycount || 0) + inc;
        this.lastpress = this.lastpress || Date.now();
        // if < than 3 keypresses and < 300ms since the last search, don't
        // trigger another one. do ensure there's a timeout set
        if (this.keycount < 3 && Date.now() - this.lastpress < 350) {
          if (!this.timeout && timeout)
            this.timeout = setTimeout(keyup.bind(this, event, 'no-timeout'), 350);
          return;
        }
      }
      this.search(event);
    },
    onnext: function (event) {
      event.event.preventDefault();
      event.event.stopImmediatePropagation();
      this.focus(1);
    },
    onprev: function (event) {
      event.event.preventDefault();
      event.event.stopImmediatePropagation();
      this.focus(-1);
    },
    search: function (event) {
      // reset state
      clearTimeout(this.timeout);
      this.cursor = this.keycount = this.lastpress = this.timeout = 0;
      this.matches = [];
      this.messages.val('').removeClass('error');
      // start the search
      if (this.frame)
        this.frame.reset();
      else
        this.frame = new search_frame();
      if (event)
        this.term =
          event.target.value.toLowerCase().replace(REGEXPS.WHITESPACE, ' ');
      if (this.term && this.term.length) {
        this.clear_matches();
        this.walk(this.searcharea.children(':not(style)').get(), 0);
        if (this.matches.length) {
          this.focus(0, true);
        } else {
          this.messages.val('No matches').addClass('error');
        }
      }
    },
    walk: function(elements) {
      for (var i = 0, len = elements.length; i < len; ++i) {
        var node = elements[i];
        switch (node.nodeType) {
        // scan text nodes for all matches
        case Node.TEXT_NODE:
          this.find_in_text(node);
          break;
        case Node.ELEMENT_NODE:
          console.debug(node.getAttribute('class'), ':', node.getAttribute('style'));
          if (!REGEXPS.DISPLAY_NONE.test(node.getAttribute('style')))
            switch (node.nodeName) {
            case 'INPUT':
            case 'SELECT':
            case 'TEXTAREA':
              this.find_in_input(node);
              this.frame.reset();
              break;
            case 'STYLE':
            case 'SCRIPT':
              // skip
              break;
            default:
              if (node.childNodes.length)
                this.walk(node.childNodes);
            }
          break;
        }
      }
    }
  },
  mounted: function () {
    var $el = $(this.$el);
    this.messages = $el.find('.chi-search-messages');
    this.searcharea =
      $(typeof this.target === 'string' ? '#' + this.target : this.target);
    $el.data('chi-searchbox', this);
    console.debug(this);
  },
  props: {
    id: {default: 'chi_searchbox'},
    target: {}
  }
};
</script>
